// extracted by mini-css-extract-plugin
module.exports = {"widget":"MyProfileNavbarLayout_widget__sob30","linkItem":"MyProfileNavbarLayout_linkItem__kfEEl","linkItemHighlight":"MyProfileNavbarLayout_linkItemHighlight__1ZS5x"};